import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

import ListGroupItem from './ListGroupItem';
import Replaceable from '~/components/higher-order/ReplaceableComponents';
import Styleable, {
  createStyledComponent,
} from '~/App/Components/HOC/Styleable';

export const styles = {
  container: () => ({
    marginBottom: '20px',
    paddingLeft: 0,
  }),
};

export const components = {
  Container: createStyledComponent('ul', 'container'),
};

const listGroupPropTypes = {
  components: PropTypes.any,
  styles: PropTypes.any,
  getStyles: PropTypes.func,
};

export type ListGroupProps = InferProps<typeof listGroupPropTypes>;

@Styleable(styles)
@Replaceable(components)
class ListGroup extends React.PureComponent<ListGroupProps> {
  static Item: typeof ListGroupItem;

  static propTypes = listGroupPropTypes;

  render() {
    const { components, styles, ...props } = this.props;
    const { Container } = components;

    return <Container getStyles={this.props.getStyles} {...props} />;
  }
}

ListGroup.Item = ListGroupItem;

export default ListGroup;
